export default __webpack_public_path__ + "static/media/coinbasewallet.a3a7d7fd.svg";